import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
const token = localStorage.getItem('authToken');
class AddVrat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textInput: "",
            userName: "",
            title: "",
            category: "",
            subCategory: "",
            areaInput: "",
            subCategoryData: [],
            categoryData: [],
            city: "",
            date:"",
            isDateValid: true,
            submissionStatus: null,
            currentImageUrl: null,
            submeet: false,
            errors: [],
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
        };
    }

    async componentDidMount() {
        this.fetchData()
        this.fetchDataSub()
    }

    fetchData = async () => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/vratsubcategory`,{
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.data) {
                this.setState({ categoryData: response.data.Varat });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    fetchDataSub = async () => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/vratsubsubcategory`,{
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.data) {
                this.setState({ subCategoryData: response?.data?.Varat });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };




    handleChange = (e) => {
        const files = Array.from(e.target.files);
        const errors = [];

        files.forEach((file) => {
            if (file.size > this.state.maxSize) {
                errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
            } else {
                this.setState({
                    textInput: file,
                    currentImageUrl: URL.createObjectURL(file),
                });
            }
        });

        this.setState({ errors });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ submeet: true });

        const { textInput, city, date, title, areaInput, category,subCategory } = this.state;

        // if (!textInput || !userName || !title || !areaInput || !category) {
        //   return;
        // }

        try {

            const formData = new FormData();
            formData.append('image', textInput);
            formData.append('title', title);
            formData.append('description', areaInput);
           
            formData.append('category', category);
            formData.append('subcategory', subCategory);

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                
                        Authorization: `Bearer ${token}`,
                 
                }
            };
            console.log("1");

            const response = await axios.post("https://samaj.aasmo.in/api/admin/vrat", formData, config);

            if (response.status === 201) {
                console.log("2");
                this.setState({ submissionStatus: 'success', submeet: false });
                setTimeout(() => {
                  this.props.history.push("/vratAurTyoharlist");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            this.setState({ submissionStatus: 'error' });
        }
    };

    render() {
        const { textInput, isDateValid, date, title, currentImageUrl, city, userName, category, subCategory,subCategoryData,categoryData, submeet, areaInput, submissionStatus } = this.state;
        const isNameValid = userName.trim().length > 0;
        const isTitleValid = title.trim().length > 0;
        const isCityValid = city?.trim().length > 0;


        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Add Vrat Aur Tyohar</h2>
                    </div>
                    <div className="body">
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label>Title</label>
                                <input
                                    className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                                    value={title}
                                    name="title"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ title: e.target.value });
                                    }}
                                />
                                {!isTitleValid && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>


                            <div className="form-group">
                                <label htmlFor="bloodGroup">Sub Category</label>
                                <select
                                    className={`form-control ${submeet && !category && "parsley-error"
                                        }`}
                                    value={category}
                                    name="category"
                                    required=""
                                    onChange={(e) => {
                                        this.setState({ category: e.target.value });
                                    }}
                                >
                                    <option value="">Select Category</option>
                                    {categoryData && categoryData.map((key) => (
                                        <option key={key.id} value={key.id}>{key.name}</option>
                                    ))}
                                </select>
                                {submeet && !category ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">Category is required.</li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label htmlFor="bloodGroup">Sub Sub Category</label>
                                <select
                                    className={`form-control ${submeet && !subCategory && "parsley-error"
                                        }`}
                                    value={subCategory}
                                    name="subCategory"
                                    required=""
                                    onChange={(e) => {
                                        this.setState({ subCategory: e.target.value });
                                    }}
                                >
                                    <option value="">Select subCategory</option>
                                    {subCategoryData && subCategoryData.map((key) => (
                                        <option key={key.id} value={key.id}>{key.name}</option>
                                    ))}
                                </select>
                                {submeet && !subCategory ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">subCategory is required.</li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>Image</label>

                                {currentImageUrl && (
                                    <div>
                                        <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                                    </div>
                                )}
                                <input
                                    type="file"
                                    className={`form-control ${!textInput && submeet && "parsley-error"}`}
                                    name="textInput"
                                    required=""
                                    onChange={this.handleChange}
                                />
                                {!textInput && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">This value is required.</li>
                                    </ul>
                                ) : null}
                            </div>

                        

                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    className={`form-control ${areaInput === "" && submeet && "parsley-error"
                                        }`}
                                    value={areaInput}
                                    cols="30"
                                    name="textarea"
                                    required=""
                                    rows="5"
                                    onChange={(e) => {
                                        this.setState({ areaInput: e.target.value });
                                    }}
                                ></textarea>
                                {areaInput === "" && submeet ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            {submissionStatus === 'success' && (
                                <div className="alert alert-success" role="alert">
                                    Form submitted successfully!
                                </div>
                            )}

                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter (connect(mapStateToProps, { notifyGeneralInfo })(AddVrat));
